const getCustomerRef = (payload, custRefQS) => {
  if (custRefQS !== "") {
    return custRefQS;
  } else if (typeof payload.customerID === "undefined") {
    return undefined;
  }
  return payload.customerID;
};

export default getCustomerRef;
